module.exports = __webpack_public_path__ + "img/all_exam.95917f98.png";